import { useState } from "react";

type Contact = {
  title: string;
  content: string;
  action: {
    href: string;
    text: string;
  };
};

type SocialLink = {
  href: string;
  label: string;
};

type ContactSectionProps = {
  contacts: Contact[];
  socialLinks: SocialLink[];
};

const EMAIL = "zaiman670@gmail.com";

const ContactSection = ({ contacts, socialLinks }: ContactSectionProps) => {
  const [copied, setCopied] = useState(false);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(EMAIL);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1800);
    } catch {
      window.location.href = `mailto:${EMAIL}`;
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-section__topline" data-reveal>
        <span>05 / Contact</span>
        <span>Kajang · Malaysia · MYT</span>
      </div>

      <div className="contact-section__headline" data-reveal>
        <p>Have an idea, opportunity, or difficult problem?</p>
        <h2>
          Let&apos;s build
          <span>something useful.</span>
        </h2>
      </div>

      <div className="contact-section__actions" data-reveal>
        <a
          className="contact-email"
          href={`mailto:${EMAIL}`}
          data-cursor="Write"
        >
          {EMAIL}
          <span aria-hidden="true">↗</span>
        </a>
        <button type="button" className="copy-email" onClick={copyEmail}>
          {copied ? "Email copied" : "Copy email"}
        </button>
      </div>

      <div className="contact-section__details" data-reveal>
        <div>
          <span>Direct</span>
          <ul>
            {contacts.map((contact) => (
              <li key={contact.title}>
                <a
                  href={contact.action.href}
                  target={
                    contact.action.href.startsWith("http")
                      ? "_blank"
                      : undefined
                  }
                  rel={
                    contact.action.href.startsWith("http")
                      ? "noreferrer"
                      : undefined
                  }
                >
                  <span>{contact.title}</span>
                  <strong>{contact.content}</strong>
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <span>Elsewhere</span>
          <ul>
            {socialLinks.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  target={link.href.startsWith("http") ? "_blank" : undefined}
                  rel={link.href.startsWith("http") ? "noreferrer" : undefined}
                >
                  {link.label}
                  <span aria-hidden="true">↗</span>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <footer className="site-footer">
        <a href="#home" aria-label="Back to top">
          MANZA
        </a>
        <p>
          Full-stack web and mobile software developer. Available for selected
          freelance work and collaborations.
        </p>
        <span>© {new Date().getFullYear()} Zul Aiman</span>
        <a href="#home">Back to top ↑</a>
      </footer>
    </section>
  );
};

export default ContactSection;
